import React from "react";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";

// Minimal, always-centered markdown renderer for short card blurbs
// (title/description previews). Deliberately does not support the
// long-form section-splitting, tables, or button-link syntax that
// MarkdownComponent handles for full project pages — use that for
// ProjectPage's main content instead.

// Strips the legacy [TA-CENTER]/[TA-START]/[TA-END] prefixes some content
// still carries from MarkdownComponent's alignment system — this renderer
// always centers, so the prefix is just noise to drop.
const stripAlignmentPrefix = (text) =>
	typeof text === "string" ? text.replace(/^\[TA-(CENTER|START|END)\]\s*/, "") : text;

const List = ({ children }) => <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>{children}</ul>;
const ListItem = ({ children }) => <li>{children}</li>;

// Inline color syntax: ?#RRGGBB?colored text?#RRGGBB? — same convention MarkdownComponent uses.
const parseCustomStyles = (parts) => {
	const elements = [];
	let isStyling = false;
	let styleColor = null;

	parts.forEach((part, index) => {
		if (typeof part === "string") {
			const matches = part.split(/(\?[#][0-9A-Fa-f]{6}\?)/);
			matches.forEach((match) => {
				if (match.match(/\?([#][0-9A-Fa-f]{6})\?/)) {
					if (!isStyling) {
						styleColor = match.slice(1, -1);
						isStyling = true;
					} else {
						isStyling = false;
					}
				} else if (isStyling) {
					elements.push(<span key={`${index}-${match}`} style={{ color: styleColor }}>{match}</span>);
				} else {
					elements.push(match);
				}
			});
		} else {
			elements.push(part);
		}
	});

	return elements;
};

const Paragraph = ({ children }) => {
	const styledChildren = parseCustomStyles(React.Children.toArray(children));
	return <p style={{ margin: "5px 0" }}>{styledChildren}</p>;
};

function CenteredMarkdown({ markdown }) {
	if (!markdown) return null;
	return (
		<div style={{ textAlign: "center", width: "100%" }}>
			<ReactMarkdown remarkPlugins={[gfm]} components={{ p: Paragraph, ul: List, li: ListItem }}>
				{stripAlignmentPrefix(markdown)}
			</ReactMarkdown>
		</div>
	);
}

export default CenteredMarkdown;
